import { ChangeEvent, useEffect, useRef, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../../auth/UseAuth'
import { captchaSiteKey } from '../../../types/constants'
import { LoadingSpinner } from '../../common/LoadingSpinner/LoadingSpinner'

interface ContactFormComponentProps {
  hidden?: boolean
  loading: boolean
  handleSubmit: (form: { [field: string]: string }, captchaToken: string) => void
}

export function ContactFormComponent(props: ContactFormComponentProps) {
  const [form, setForm] = useState<{ [field: string]: string }>({})
  const [captchaToken, setCaptchaToken] = useState<string>('')
  const [emailValid, setEmailValid] = useState<boolean>(true)

  const { user } = useAuth()
  const { t } = useTranslation()

  useEffect(() => {
    setForm({
      firstname: user?.firstName ?? '',
      lastname: user?.lastName ?? '',
      email: user?.email ?? '',
      confirmEmail: '',
      userDisplayName: user?.displayName ?? '',
    })
  }, [user?.displayName, user?.email, user?.firstName, user?.lastName])

  const onInputChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { value, name } = e.currentTarget
    const newForm = { ...form }

    newForm[name] = value

    setForm(newForm)
  }

  const onCaptchaChange = (token: string | null) => {
    if (token) {
      setCaptchaToken(token)
    } else {
      setCaptchaToken('')
    }
  }

  const handleSubmit = () => {
    const emailsMatch = form.confirmEmail === form.email
    setEmailValid(emailsMatch)
    if (emailsMatch) {
      props.handleSubmit(form, captchaToken)
    }
  }

  const recaptcha = useRef<ReCAPTCHA>(null)

  return (
    <div className={'fade contactForm ' + (!props.hidden ? 'in' : 'out')}>
      <div className="box-title center">
        <span>{t('SUBMIT_FORM_TITLE')}</span>
      </div>
      <div className="box2">
        <p>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
          dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet
          clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,
          consetetur sadipscing elitr.
        </p>
        <div className="row">
          <div className="col-6 col-md-3">
            <div className="inputArea">
              <input
                type="text"
                placeholder="Name"
                name="firstname"
                className="transparent"
                onChange={(e) => onInputChange(e)}
                defaultValue={form.firstname}
                disabled={!!user?.firstName}
              />
            </div>
          </div>
          <div className="col-6 col-md-3">
            <div className="inputArea">
              <input
                type="text"
                placeholder="Surname"
                name="lastname"
                className="transparent"
                onChange={(e) => onInputChange(e)}
                defaultValue={form.lastname}
                disabled={!!user?.lastName}
              />
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="inputArea">
              <input
                type="tel"
                placeholder="Telephone"
                name="phone"
                className="transparent"
                onChange={(e) => onInputChange(e)}
                defaultValue={form.telephone}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6 col-md-3">
            <div className="inputArea">
              <input
                type="email"
                placeholder={t('EMAIL') ?? ''}
                name="email"
                className="transparent"
                onChange={(e) => onInputChange(e)}
                defaultValue={form.email}
                disabled={!!user?.email}
              />
            </div>
          </div>
          <div className="col-6 col-md-3">
            <div className={emailValid ? 'inputArea' : 'inputArea searchFailed'}>
              <input
                type="email"
                placeholder={t('CONFIRM_EMAIL') ?? ''}
                name="confirmEmail"
                className="transparent"
                onChange={(e) => onInputChange(e)}
                defaultValue={form.confirmEmail}
              />
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="inputArea">
              <input
                type="text"
                placeholder="Company/Branch address"
                name="address"
                onChange={(e) => onInputChange(e)}
                className="transparent"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="inputArea">
              <textarea
                style={{ height: 145 }}
                placeholder={t('SUPPORT_MESSAGE') ?? ''}
                name="message"
                className="transparent"
                onChange={(e) => onInputChange(e)}
                defaultValue={form.message}
              ></textarea>
            </div>
          </div>
          <div className="col-12 col-md-6">
            {/*<div className="inputBlock">
              <label>Subject</label>
              <Dropdown multiselect={true} items={subjects} onChange={(e) => onSubjectChange(e)}></Dropdown>
            </div>*/}
            <br />
            <ReCAPTCHA onChange={onCaptchaChange} ref={recaptcha} sitekey={captchaSiteKey} />
            {props.loading ? (
              <LoadingSpinner />
            ) : (
              <a onClick={handleSubmit} className={captchaToken ? 'btn' : 'btn disabled'}>
                {t('SUBMIT')}
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
